module.exports = __webpack_public_path__ + "static/media/warning-login.d5b1383d.svg";